'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class participantModel extends ngDepModel
{
	a3_participants_legal_status_other = false;
	a3_participants_legal_status_other_value = '';

	a3_participants_representative_phoneInput = '';
	a3_participants_contact_phoneInput = '';
	
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	afterSetup(data){
		if(typeof(this.a3_participants_legal_status) === 'object'){
			this.a3_participants_legal_status = Object.values(this.a3_participants_legal_status);
		}
		this.makeCetField('end_date_date', true);
		this.end_date_date_cet.setHours(12);
		this.makeCetField('starting_date_date', true);
		this.starting_date_date_cet.setHours(12);
		if(typeof(this.end_date_date) !== 'undefined' && this.end_date_date > 0){
			this.end_date_obj = new Date(this.end_date_date * 1000);
		}
		else{
			this.end_date_obj = new Date();
		}
		if(typeof(this.starting_date_date) !== 'undefined' && this.starting_date_date > 0){
			this.starting_date_obj = new Date(this.starting_date_date * 1000);
		}
		else{
			this.starting_date_obj = new Date();
		}
	}
	
	getValue(name){
		switch(name){
			case 'a3_participants_vat_recoverable':
//				return this.getClassifValue(name, 'yesno');
				return this.getClassifValue(name, 'vat_recoverable');
			case 'a3_participants_country_id':
			case 'a3_participants_country':
				return this.getClassifValue('a3_participants_country_id', 'country');
			case 'a3_participants_legal_status':
				return this.getClassifOtherValue(name, 'legalstatus', ((this.a3_participants_legal_status_other) ? this.a3_participants_legal_status_other_value : false));
			case 'a3_participants_role':
				return this.getClassifValue(name, 'application_role');
			case 'starting_date':
				if(this.starting_date_type == 1){
					return this.s('$filter')('tr')('as_specified');
				}
				return this.s('$filter')('u2date')(this.starting_date_date, 'dd/MM/y');
			case 'end_date':
				return this.s('$filter')('u2date')(this.end_date_date, 'dd/MM/y');
			case 'grant_amount':
				return this.s('$filter')('currency')(this[name]);
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}
